






























































import {Component, Vue} from 'vue-property-decorator';
import ICognitoUserData from '@/types/cognitoUserData';
import {
  Getter,
  Action,
} from 'vuex-class';

@Component
export default class SignIn extends Vue {
  public $refs!: {
    form: any,
  };

  private loading: boolean = false;
  private user: any = {
    username: null,
    password: null,
  };

  @Getter('guest/auth/username') private username!: string;
  @Action('guest/auth/forgotPasswordSubmit') private forgotPasswordSubmit!: (user: ICognitoUserData) => Promise<any>;
  @Action('guest/auth/signIn') private signIn!: (user: ICognitoUserData) => Promise<any>;
  @Getter('guest/auth/challenge') private challenge!: any;
  @Getter('common/rules/all') private rules!: any[];

  public mounted() {
    if (this.username) {
      this.user.username = this.username;
    }
  }

  private async Confirm(e) {
    e.preventDefault();
    if (this.$refs.form.validate()) {
      this.loading = true;
      const res = await this.forgotPasswordSubmit(this.user);
      if (res) {
        this.user.password = this.user.newPassword;
        const res2 = await this.signIn(this.user);
        if (res2) {
          this.$router.push({name: 'UserBase'});
        } else {
          this.$router.push({name: 'SignIn'});
        }
      }
      this.loading = false;
    }
  }
}
